import { Config } from 'core/common/contexts';
import { normalizeError } from 'core/common/errors';
import { Logger } from 'core/common/services/logger/interfaces';
import { delay } from 'core/common/utils/delay';
import { HttpClientDecorator } from './HttpClientDecorator';
import { HttpRequestConfig } from './entities';
import { HttpClient } from './interfaces';

export class HttpClientWithRetry extends HttpClientDecorator {
  constructor(
    httpClient: HttpClient,
    private readonly logger: Logger,
    private readonly config: Config,
  ) {
    super(httpClient);
  }

  async get<ResponseData = unknown, ResponseMeta = unknown>(
    url: string,
    config: HttpRequestConfig = {},
  ): Promise<{ data: ResponseData; meta: ResponseMeta; success: boolean }> {
    const { maxRequestRetries, requestRetryDelay } = this.config.funnelBuilder;

    for (let attempt = 0; attempt <= maxRequestRetries; attempt += 1) {
      try {
        return await super.get<ResponseData, ResponseMeta>(url, config);
      } catch (error) {
        if (attempt === maxRequestRetries) {
          throw error;
        }

        this.logger.warn(
          `Retrying GET ${url} after error (attempt ${attempt + 1}/${maxRequestRetries}): ${normalizeError(error)}`,
        );

        await delay(requestRetryDelay * 2 ** attempt);
      }
    }

    throw new Error(`Failed to GET ${url} after ${maxRequestRetries} retries`);
  }
}
